module.exports = __webpack_public_path__ + "img/2.2903787f.png";